'use strict';

angular.module('shop').component('product', {
	templateUrl: 'component/product.html',
	bindings: {
		product: '<'
	},
	controller: function() {
		var self = this;

		this.show = false;

		self.$onInit = function() {
			if (!self.product.priceDefault || self.product.priceDefault == self.product.price) {
				self.discount = 0;
			} else {
				var amount = self.product.priceDefault - self.product.price;
				self.discount = Math.round((amount / self.product.priceDefault) * 100);
			}

			if (self.product.imageOffer && self.product.imageOffer !== 'http://vaxjo2.sigmatechnology.se/Backend2/Files/Webshop/' && self.product.imageOffer !== 'https://backend.matkomfort.se/Files/Webshop/') {
				self.offerImg = self.product.imageOffer;
			}
		};
	}
});